import Landing from "./pages/Landing.vue"
import Blog from "./pages/Blog.vue"
import Collection from "./pages/Collection.vue"
import Newsletter from "./pages/Newsletter.vue"
import Pages from "./pages/Pages.vue"
import SearchResults from "./pages/SearchResults.vue"

export default [

    {
        path: '/',
        component: Landing,
    },

    {
        path: '/blog/:collection*/:id',
        component: Blog
    },

    {
        path: '/edit/:id',
        component: Blog,
        name: "edit"
    },

    {
        path: '/collection/:id',
        component: Collection
    },

    {
        path: '/pages/:id',
        component: Pages
    },

    {
        path: '/search',
        component: SearchResults
    },

    {
        path: '/newsletter',
        component: Newsletter
    },
]



// WEBPACK FOOTER //
// ./src/routes.js